<script>
import ProfileRepository from "@/repositories/ProfileRepository";
import AdminRepository from "@/repositories/AdminRepository";
import UserRepository from "@/repositories/UserRepository";

export default {
  methods: {
    async onStudentEdit(form) {
      const response = await ProfileRepository.update(form);
    },
    async onProfessorCreate(form) {
      const response = await AdminRepository.createProfessor(form);
    },
    async onStudentCreate(form) {
      const response = await UserRepository.create(form);
    }
  }
};
</script>
